import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import MealPlan from './modules/Content/MealPlan';
// import * as serviceWorker from './serviceWorker';
import Theme from './Theme';

ReactDOM.render(
  <React.StrictMode>
    <Theme>
      <MealPlan />
    </Theme>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
